export const maquetaTpl = {
  modalDatos: {
    regTitle: `Detalhes do registro`,
    paymentMethod: `Forma de pagamento`,
    paymentDate: `Data do pagamento`,
    guestCount: `Número de hóspedes`,
    unspecified: `Não especificado`,
    pay: {
      DESTI: `Pagar no destino`,
      EFECT: `Dinheiro`,
      MOVIL: `Pagamento móvel`,
      OTRO: `Outras formas de pagamento`,
      PLATF: `Plataforma de pagamento`,
      TARJT: `Cartão de crédito`,
      TRANS: `Transferência bancária`,
      TREG: `Cartão-presente`,
    },
  },
  whatsapp: {
    title: `Acesso exclusivo ao WhatsApp Business`,
    body: `Para usar o recurso do WhatsApp Business, é necessária uma assinatura ativa do WhatsApp Business Personal. Essa opção foi criada para oferecer ferramentas extras e recursos avançados que impulsionam a experiência do seu negócio.`,
  },
  nav: {
    welcome: `Bem-vindo`,
    manager: `Gerente`,
    logout: `Sair`,
    logoutError: `Desculpe, ocorreu um erro ao sair`,
  },
  subnav: {
    home: `Início`,
    clients: `Clientes`,
    prices: `Preços`,
    payments: `Pagamentos`,
    userManagement: `Gestão de usuários`,
  },
};
